import { REWARD_TYPE } from './rewards';

export enum QUEST_BACKGROUND_FLAG {
	ORANGE = 'orange',
	BLUE = 'blue',
	PURPLE = 'purple',
	GREEN = 'green',
	DARK_BLUE = 'darkBlue'
}

export enum QUEST_PROGRESS_STATUS {
	NO_PROGRESS = 'no_progress',
	IN_PROGRESS = 'in_progress',
	COMPLETED = 'completed',
	REWARD_RECEIVED = 'reward_received'
}

export enum QUESTS_DISPLAY_TYPE {
	BLOCKS = 'blocks',
	MAP = 'map'
}

export enum USER_REWARD_STATUS {
	EARNED = 'earned',
	PENDING = 'pending',
	COMPLETED = 'completed',
	FAILED = 'failed',
	ALL_RETRIES_FAILED = 'all_retries_failed'
}

export enum QUEST_DATE_STATUS {
	NOT_STARTED = 'not_started',
	STARTED = 'started',
	ENDED = 'ended'
}

export type QuestCategory = {
	id: string;
	image_url: string;
	image_svg_url: string;
	main: boolean;
	name: string;
	position: number;
	slug: string;
};

export type PrizeType = {
	id: string;
	image_url: string;
	name: string;
	position: number;
};

export type AvatarType = {
	id: string;
	image_url: string;
};

export type QuestReward = {
	position: number;
	id: string;
	name: string;
	description: string;
	reward_type: REWARD_TYPE;
	amount: string;
	currency: string;
	image_url: string;
};

export type UserReward = {
	amount: string;
	currency: string;
	id: string;
	reward_type: REWARD_TYPE;
	reward: QuestReward;
	source: string;
	source_object_id: string;
	status: USER_REWARD_STATUS;
};

export type QuestType = {
	id: string;
	categories: QuestCategory[];
	current_user_quest: {
		status: QUEST_PROGRESS_STATUS;
		progress: number;
	};
	description: string;
	short_description: string;
	name: string;
	date_end: string;
	date_start: string;
	image: string;
	is_image_cover: boolean;
	backgroundColor: QUEST_BACKGROUND_FLAG;
	modal_header_image_url: string;
	rewards: QuestReward[];
	timer: boolean;
	endless: boolean;
	url: string | null;
	frontend_state: QUEST_DATE_STATUS;
	is_mirror_link: boolean;
};

export type QuestGroupInQuest = {
	position: number;
	id: string;
	name: string;
};

export type QuestGroupType = {
	background_gradient: QUEST_BACKGROUND_FLAG;
	background_image_url: string;
	button_text: string;
	date_end: string;
	date_start: string;
	description: string;
	display_type: QUESTS_DISPLAY_TYPE;
	id: string;
	image_url: string;
	is_image_cover?: boolean;
	map_image_url: string;
	name: string;
	position: number;
	categories: QuestCategory[];
	rewards: QuestReward[];
	timer: boolean;
	completed_user_quests_count: number;
	onboarding_quests: boolean;
	quests_count: number;
	tournament_type: boolean;
	prizes: PrizeType[];
	endless: boolean;
	current_user_placement?: {
		position: number;
		tournament_points: number;
	};
};

export type QuestGroupWithQuestsType = {
	background_gradient: QUEST_BACKGROUND_FLAG;
	background_image_url: string;
	button_text: string;
	date_end: string;
	date_start: string;
	description: string;
	display_type: QUESTS_DISPLAY_TYPE;
	id: string;
	image_url: string;
	is_image_cover?: boolean;
	map_image_url: string;
	name: string;
	position: number;
	categories: QuestCategory[];
	rewards: QuestReward[];
	timer: boolean;
	completed_user_quests_count: number;
	onboarding_quests: boolean;
	quests_count: number;
	tournament_type: boolean;
	quests: QuestType[];
	prizes: PrizeType[];
};

export type QuestGroupSection = {
	id: string;
	name: string;
	position: number;
	quest_groups: QuestGroupType[];
};

export type TournamentRating = {
	tournament_points: number;
	name: string;
	position: number;
};
